"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var tableSelectors_1 = require("./components/tableSelectors");
var AddRowButton_1 = __importDefault(require("./components/Buttons/AddRowButton"));
var RowActionButtons_1 = __importDefault(require("./components/Buttons/RowActionButtons"));
var TextAreaField_1 = __importDefault(require("./components/FormFields/TextAreaField"));
var ToggleEditableButton_1 = __importDefault(require("./components/Buttons/ToggleEditableButton"));
var TextField_1 = __importDefault(require("./components/FormFields/TextField"));
/**
 * Static table component with no edit option
 */
var TableWidget = function (_a) {
    var _b = _a.tableProps, schema = _b.schema, rows = _b.rows, currentTableObj = _a.currentTableObj, editable = _a.editable;
    var t = (0, react_i18next_1.useTranslation)()[0];
    var _c = (0, react_1.useState)(false), tableHover = _c[0], setTableHover = _c[1];
    var editMode = currentTableObj === null || currentTableObj === void 0 ? void 0 : currentTableObj.editMode;
    var onMouseEnterTable = function () {
        setTableHover(true);
    };
    var onMouseLeaveTable = function () {
        setTableHover(false);
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        editable && (react_1.default.createElement(ToggleEditableButton_1.default, { currentTableObj: currentTableObj, editMode: editMode, toggleEditMode: function () { return currentTableObj === null || currentTableObj === void 0 ? void 0 : currentTableObj.toggleEditMode(); }, t: t, disableEditSchema: schema.disableEditSchema, hasSchemaFields: schema.fields.length > 0 })),
        react_1.default.createElement("table", { id: 'content-table-widget', onMouseEnter: onMouseEnterTable, onMouseLeave: onMouseLeaveTable, style: __assign(__assign({ borderCollapse: 'collapse', width: '100%', maxHeight: '100%' }, schema.styles), (tableHover ? { boxShadow: '0 0 0 2px #EBEBEB' } : {})) },
            react_1.default.createElement("tbody", null,
                rows.map(function (row, rowIndex) { return (react_1.default.createElement("tr", { key: "row-".concat(rowIndex), style: { position: 'relative' } }, 
                // first render columns based on schema
                schema.fields.map(function (mainTableField, columnIndex) { return (react_1.default.createElement("td", { key: "cell-".concat(columnIndex), style: __assign({ verticalAlign: 'top' }, (0, tableSelectors_1.getMainTableFieldStyle)(schema, columnIndex)) },
                    mainTableField.subFields.map(function (_a, columnRowIndex) {
                        var type = _a.type;
                        var rowValue = (0, tableSelectors_1.getRowValueIfExists)(rows, rowIndex, columnIndex, columnRowIndex);
                        var fieldProps = {
                            schema: schema,
                            rowIndex: rowIndex,
                            columnIndex: columnIndex,
                            columnRowIndex: columnRowIndex,
                            value: rowValue,
                            currentTableObj: currentTableObj,
                            editMode: editMode
                        };
                        return (react_1.default.createElement("div", { key: "cell-".concat(columnRowIndex), style: __assign(__assign({}, (0, tableSelectors_1.getSubFieldStyle)(schema, columnIndex, columnRowIndex)), { whiteSpace: 'pre-wrap' }) }, editMode && editable ? (react_1.default.createElement(react_1.Fragment, null,
                            type === seesignage_utils_1.TableFieldType.string && react_1.default.createElement(TextField_1.default, __assign({}, fieldProps)),
                            type === seesignage_utils_1.TableFieldType.textArea && (react_1.default.createElement(TextAreaField_1.default, __assign({}, fieldProps))))) : (rowValue)));
                    }),
                    //if last column
                    editMode && editable && columnIndex === schema.fields.length - 1 && (react_1.default.createElement(RowActionButtons_1.default, { currentTableObj: currentTableObj, rowIndex: rowIndex, rowsCount: rows.length, t: t })))); }))); }),
                editMode && editable && (react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { colSpan: schema.fields.length, style: { textAlign: 'center' } },
                        react_1.default.createElement(AddRowButton_1.default, { currentTableObj: currentTableObj, t: t }))))))));
};
exports.default = TableWidget;
//# sourceMappingURL=TableWidget.js.map